export var useSettingRSCTopOfPageContent = function() {
    // TODO: Create the setting and add it here
    return false;
};
